import {
	ChangeDetectionStrategy,
	Component
} from '@angular/core';
import { ActiveBrandService } from '@go-modules/services/active-brand';
import type { BrandImage } from '@go-modules/interfaces/brands/brand.interface';

@Component({
	selector: 'go-logo',
	templateUrl: './go-logo.component.html',
	styleUrls: ['./go-logo.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class GoLogoComponent {
	constructor (private activeBrandService: ActiveBrandService) {}

	public get fullLogo (): BrandImage {
		return this.activeBrandService.getFullLogo();
	}
}
